import { render, staticRenderFns } from "./ResetPasswordRequestForm.vue?vue&type=template&id=45abb3ad&"
import script from "./ResetPasswordRequestForm.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordRequestForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports